import { render, staticRenderFns } from "./JobBoardJobs.vue?vue&type=template&id=122ad215&"
import script from "./JobBoardJobs.vue?vue&type=script&lang=js&"
export * from "./JobBoardJobs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports